import React from "react";
import { Link } from "react-router-dom";
import styles from "./WhyChoosePage.module.css";
import { popularPlaces } from "../Experiences/experiencesData";
import HeroSection from "../HomePage/sections/HeroSection";

const reasons = [
  {
    title: "Comfortable Rooms in Tweed Heads South, NSW",
    text: "Our rooms provide a comfortable place to relax after a day of travelling, sightseeing or exploring the Tweed Valley.",
    image: "/images/ARB. 2.jpg",
    alt: "A comfortable room at Arabella Motor Inn",
  },
  {
    title: "Convenient Tweed Heads South, NSW Location",
    text: "Stay close to the local attractions and services of Tweed Heads South, NSW while enjoying easy access to surrounding destinations.",
    image: "/images/ARB. 7.jpg",
    alt: "Arabella Motor Inn in Tweed Heads South, NSW",
  },
];

const extras = [
  {
    title: "Explore the Tweed Valley",
    text: "Discover beautiful scenery, local attractions, the Tweed River, galleries, markets, nature experiences and other Tweed Valley attractions.",
    image: "/images/ARB. 3.jpg",
  },
  {
    title: "Explore the Tweed Coast",
    text: "Our location makes it convenient to explore popular Tweed Coast attractions, including Kingscliff, Cabarita Beach, Fingal Head, Hastings Point and surrounding coastal destinations.",
    image: "/images/img1.jpg",
  },
  {
    title: "Near Tweed Heads",
    text: "Planning to visit Tweed Heads? Arabella Motor Inn provides a convenient motel near Tweed Heads while giving you the opportunity to stay in the peaceful surroundings of Tweed Heads South, NSW.",
    image: "/images/img2.jpg",
  },
  {
    title: "Ideal for Business & Leisure",
    text: "Whether you're travelling for work, visiting friends and family or planning a weekend getaway, our accommodation in Tweed Heads South, NSW provides a convenient base for your trip.",
    image: "/images/ARB. 8.jpg",
  },
];

const WhyChoosePage = () => {
  return (
    <div className={styles.page}>
      <HeroSection />
      <header className={styles.intro}>
        <p className={styles.kicker}>Arabella Motor Inn</p>
        <h1>Why Choose Arabella Motor Inn?</h1>
      </header>

      {reasons.map((item, index) => (
        <section
          key={item.title}
          className={`${styles.feature} ${index % 2 === 1 ? styles.featureReverse : ""}`}
        >
          <img src={item.image} alt={item.alt} />
          <div>
            <h2>{item.title}</h2>
            <p>{item.text}</p>
          </div>
        </section>
      ))}

      <section className={styles.discover}>
        <h2>Discover Things to Do Near Tweed Heads South, NSW</h2>
        <h3>Explore the Tweed Valley, Tweed Coast &amp; Surrounding Region</h3>
        <p>
          Staying at Arabella Motor Inn means you're within easy reach of a variety of local experiences.
        </p>
        <p>
          Discover things to do in Tweed Heads South, NSW, explore the natural beauty of the Tweed Valley, visit nearby coastal towns or enjoy a day trip towards Tweed Heads and the Gold Coast.
        </p>
        <h3>Popular places to visit include:</h3>
        <ul className={styles.places}>
          {popularPlaces.map((place) => (
            <li key={place}>{place}</li>
          ))}
        </ul>
        <Link to="/experiences" className={styles.exploreLink} target="_blank" rel="noopener noreferrer">
          Explore Things to Do Near Tweed Heads South, NSW →
        </Link>
      </section>

      <section className={styles.extraGrid}>
        {extras.map((item) => (
          <article key={item.title} className={styles.extraCard}>
            <img src={item.image} alt="" />
            <div>
              <h2>{item.title}</h2>
              <p>{item.text}</p>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default WhyChoosePage;
